<!-- Spinner -->
<prgov-spinner [loading]="!this.isSaving()" [overlayOpacity]="false" [bgLight]="true"></prgov-spinner>


<div>
  <div class="d-flex justify-content-between m-3" style="height: 50px;">
      <button *ngIf="!paymentCompleted" class="ml-auto" color="primary" mat-stroked-button [disabled]="this.isSaving()" (click)="close()">
        {{'payment.close' | translate}}
      </button>
  </div>

  <ng-container *ngIf="!this.transactionService.itemToEdit.HasDynamicCosts">
    <div class="payment-container">
      <div class="col-lg-12">
        <h1><b>Checkout</b></h1>
        <p> Aquí podrás abonar tus solicitudes. Selecciona el medio de pago de tu conveniencia. </p>
      </div>
    </div>
    <div class="payment-container" [ngClass]="{'d-none': paymentCompleted}">
      <div class="d-flex">
        <!-- Sección a la izquierda -->
        <div class="left-section" style="flex: 1; padding-right: 15px;">
          <div class="row mt-3 mb-3">
            <div class="col-lg-12">
              <h3 style="background-color: #155d48; color: white; padding: 10px; border-top-left-radius: 3px; border-top-right-radius: 3px;">
                SELECCIONE EL MÉTODO DE PAGO
              </h3>
              <form [formGroup]="form2">
                <mat-radio-group formControlName="PaymentMethod" >
                  <div class="radio-buttons-container">
                    <mat-radio-button class="custom-radio-button" [value]="1" [checked]="true"  (click)="handleRadioButtonClick($event, 1)">
                      <b>Tarjeta De Crédito </b>
                    </mat-radio-button>
                    <!-- <mat-radio-button class="custom-radio-button" *ngIf="calculatedAmount > 500" [value]="4"  (click)="handleRadioButtonClick($event, 4)">
                      <b>{{'payment.ach' | translate}}</b>
                    </mat-radio-button> -->
                    <mat-radio-button class="custom-radio-button"  [value]="3"   (click)="handleRadioButtonClick($event, 3)">
                      <b>{{ 'credit.useCredits' | translate }}</b>
                    </mat-radio-button>
                    <mat-radio-button *ngIf="globals.showEventCodePayment" class="custom-radio-button" [value]="5" (click)="handleRadioButtonClick($event, 5)">
                      <b>Código de Evento</b>
                    </mat-radio-button>
                    <!-- <mat-radio-button class="custom-radio-button" [disabled]="!transactionService.itemToEdit.HasPaymentPlan" [value]="2"   (click)="transactionService.itemToEdit.HasPaymentPlan ? handleRadioButtonClick($event, 2) : null">
                      <b>{{'payment.paymentPlan' | translate}}</b>
                    </mat-radio-button> -->
                  </div>
                  <div class="mb-2 mt-2" *ngIf="this.paymentPlan == 2">
                    <prgov-alerts class="d-flex justify-content-between">
                      <span>{{'payment.payInstallment' | translate}}</span>
                      <button  class="ml-5 btn-primary-outlined-mat" (click)="openDialog()">
                        <span>{{'payment.goToPlan' | translate}}</span>
                        <mat-icon>send</mat-icon>
                      </button>
                    </prgov-alerts>
                  </div>
                </mat-radio-group>
              </form>
            </div>
          </div>
          <hr>
          <div [hidden]="this.form2.controls.PaymentMethod.value !== 1" class="row">
            <div class="col-lg-12">
              <form [formGroup]="form">
                <input type="text" name="first-name" card-name style="display: none;" />
                <div class="form-group">
                  <div class="mb-3">
                    <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                      1. Ingrese los datos de su tarjeta
                    </h3>
                  </div>
                  <div>
                    Completa los detalles de tu tarjeta de crédito para procesar el pago. Asegúrate de ingresar el nombre tal como aparece en la tarjeta.
                  </div>
                  <div class="form-group pt-3">
                    <mat-form-field appearance="outline">
                      <mat-label>{{'payment.nameOnCard' | translate}} *</mat-label>
                      <input matInput type="text" formControlName="NameOnCard" />
                      <mat-hint class="materialize-red-text"
                        [hidden]="!form.controls.NameOnCard.errors || !form.controls.NameOnCard.touched">
                        {{'payment.cardError' | translate}}
                      </mat-hint>
                    </mat-form-field>
                  </div>
                  <app-credit-card-selector></app-credit-card-selector>
                  <mat-form-field appearance="outline">
                    <mat-label>{{'payment.cardNumber' | translate}} *</mat-label>
                    <input matInput type="tel" name="number" formControlName="CardNumber" (input)="formatValue($event)" />
                    <mat-hint class="materialize-red-text"
                      *ngIf="cardFormatterService.cardType=='Unknown' || form.controls.CardNumber.errors"
                      [hidden]="!form.controls.CardNumber.touched">
                      {{'payment.cardError' | translate}}
                    </mat-hint>
                  </mat-form-field>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <mat-form-field appearance="outline">
                        <mat-label>{{'payment.expiry' | translate}} (MM/YYYY) *</mat-label>
                        <input matInput type="text" name="expiry" formControlName="Expiry" mask="00 / 0000" [dropSpecialCharacters]="false" />
                        <mat-hint class="materialize-red-text"
                          [hidden]="!form.controls.Expiry.errors || !form.controls.Expiry.touched">
                          {{'payment.expError' | translate}}
                        </mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <mat-form-field appearance="outline">
                        <mat-label>CVC *</mat-label>
                        <input matInput type="text" name="cvc" formControlName="CVC" (keypress)="numberOnly($event)" maxlength="4" minlength="3" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                  2. Ingrese la dirección asociada a la tarjeta
                </h3>
                <div>
                   Ingresa la direccion asociada a tu tarjeta. Incluye dirección completa, país y código postal, asegurando que coincida con los registros para un pago sin problemas.
                </div>
                <br>
                <app-street-postal-address-form formControlName="PaymentAddress" [showHeaders]="false" [managePostal]="false" [isRequired]="true"></app-street-postal-address-form>
                <div class="card-container d-none"></div>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
      <!--         <ng-container *ngIf="(form2.controls['PaymentMethod'].value == 1)">
                <button mat-button
                        class="btn-size"
                        color="primary"
                        [disabled]="!form.valid || isSaving() || paymentType=='Unknown'"
                        (click)="tryPay()">
                  <ng-container *ngIf="!isSaving()">
                    {{'payment.paySubmit' | translate}}
                    <mat-icon>send</mat-icon>
                  </ng-container>
                  <ng-container *ngIf="isSaving()">
                    <div class="d-flex align-items-center justify-content-center spinner-wht">
                      <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                    </div>
                  </ng-container>
                </button>
              </ng-container> -->
              <ng-container *ngIf="form2.controls['PaymentMethod'].value == 3">
                  <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                    1. Abonar con créditos
                  </h3>
                  <div>
                    Aplica los créditos disponibles en tu cuenta para abonar este pago. Los créditos se descontaran automáticamente del total. Asegúrate de que los créditos sean suficientes para cubrir el pago.
                  </div>
                  <div>
                    ({{ 'credit.currentBalance' | translate }}:<span class="credit-green-label">&nbsp;{{ creditService.balance?.CurrentCreditAmount ? creditService.balance?.CurrentCreditAmount : 0 | currency }} )</span>
                  </div>
                  <br>
                  <button
                    mat-button
                    class="btn-size"
                    color="primary"
                    [disabled]="isSaving()"
                    (click)="tryBuyCredit()">
                    <span>Añadir Crédito</span>
                    <mat-icon>add</mat-icon>
                  </button>
                  <br>
                  <br>
                  <!-- <button mat-button
                          class="btn-size"
                          color="primary"
                          (click)="tryPayCredit()">
                    <ng-container *ngIf="!isSaving()">
                      {{'payment.paySubmit' | translate}}
                      <mat-icon>send</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="isSaving()">
                      <div class="d-flex align-items-center justify-content-center spinner-wht">
                        <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                      </div>
                    </ng-container>
                  </button> -->
              </ng-container>

              <ng-container *ngIf="form2.controls['PaymentMethod'].value == 5 && globals.showEventCodePayment">
                <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                  1. Ingrese su código de evento
                </h3>
                <div class="mb-3">
                  Introduce el código de evento otorgado. El código permite someter su trámite sin costo adicional hasta agotar la cuota disponible.
                </div>
                <div class="d-flex align-items-center mb-2">
                  <mat-form-field appearance="outline" style="flex:1; margin-bottom: -1.34375em">
                    <mat-label>Código de Evento</mat-label>
                    <input matInput type="text" [(ngModel)]="eventCode" [ngModelOptions]="{standalone: true}" (ngModelChange)="onEventCodeChange()" (keyup.enter)="validateEventCode()" [disabled]="eventCodeValidating" style="text-transform:uppercase" />
                  </mat-form-field>
                  <button mat-stroked-button color="primary" [disabled]="!eventCode || eventCodeValidating" (click)="validateEventCode()" class="ml-2" style="height: 56px;">
                    <span *ngIf="!eventCodeValidating">Validar</span>
                    <mat-spinner *ngIf="eventCodeValidating" [diameter]="20"></mat-spinner>
                  </button>
                </div>
                <div *ngIf="eventCodeValid" class="alert alert-success d-flex align-items-center mt-3">
                  <mat-icon class="mr-2">check_circle</mat-icon>
                  <span>Código válido. Usos restantes: <strong>{{ eventCodeRemainingUses }}</strong></span>
                </div>
                <div *ngIf="!eventCodeValid && eventCodeError" class="alert alert-danger d-flex align-items-center mt-3">
                  <mat-icon class="mr-2">error</mat-icon>
                  <span>{{ eventCodeError }}</span>
                </div>
              </ng-container>

              <ng-container *ngIf="form2.controls['PaymentMethod'].value == 4">
                <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                  1. Ingrese los detalles de su cuenta bancaria
                </h3>
                <div>
                  Introduce los datos de tu cuenta, como el número de cuenta, número de ruta y código postal. Aségurate de que toda la información sea precisa y que haya fondos suficientes en tu cuenta para un procesamiento existoso del pago.
                </div>
                <br>
                <form [formGroup]="form">
                  <div class="row mb-3">
                    <div class="col-md-12 col-lg-12">
                      <mat-form-field appearance="outline">
                        <mat-label>{{'ach.accountNumber' | translate}}</mat-label>
                        <input matInput type="text" formControlName="AccountNumber" />
                        <mat-hint class="materialize-red-text mb-1" *ngIf="form.controls.AccountNumber.errors">
                          {{'ach.validAccountNumber' | translate}}
                        </mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-12 col-lg-12">
                      <mat-form-field appearance="outline">
                        <mat-label>{{'ach.routingNumber' | translate}}</mat-label>
                        <input matInput type="text" formControlName="RoutingNumber" />
                        <mat-hint class="materialize-red-text mb-1" *ngIf="form.controls.RoutingNumber.errors">
                          {{'ach.validRoutingNumber' | translate}}
                        </mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-12 col-lg-6">
                      <mat-form-field appearance="outline">
                        <mat-label class="t-w-w-s">{{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_POSTAL_CODE' | translate}}</mat-label>
                        <input mask="00000" matInput formControlName="PostalCode" >
                        <mat-hint class="materialize-red-text"
                          [hidden]="!form.controls.PostalCode.errors || !form.controls.PostalCode.touched">
                          {{'GLOBAL.REQUIRED_FIELD' | translate}}
                        </mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
              <!--     <button mat-button
                          class="btn-size"
                          color="primary"
                          (click)="tryPayAch()">
                    <ng-container *ngIf="!isSaving()">
                      {{'payment.paySubmit' | translate}}
                      <mat-icon>send</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="isSaving()">
                      <div class="d-flex align-items-center justify-content-center spinner-wht">
                        <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                      </div>
                    </ng-container>
                  </button> -->
                </form>
              </ng-container>
            </div>
          </div>
          <div class="row" *ngIf="serverError!=''">
            <div class="col col-sm-12">
              <div class="server-error h4">{{this.serverError}}</div>
            </div>
          </div>
          <div class="mb-5"></div>
        </div>

        <!-- Sección a la derecha -->
        <div class="right-section" style="flex: 1; padding-left: 15px;">
          <div class="row mt-3 mb-3">
            <div class="col-lg-12">
              <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                ORDEN DE SOLICITUDES A ABONAR
              </h3>
            </div>
          </div>
          <div class="row" style="justify-content: center;">
            <div class="col col-lg-12">
        <!--       <h2>{{'payment.title' | translate}}</h2> -->
<!--            <div class="d-flex justify-content-between align-items-center">-->
<!--              <h3 class="flex-grow-1" [innerHTML]="transactionService.itemToEdit.ProcessName | multiLang"></h3>-->
<!--              <span><b>{{ calculatedAmount | currency }}</b></span>-->
<!--            </div>-->

              <div class="table-container m-b-10" >
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <h3 [innerHTML]="transactionService.itemToEdit.ProcessName | multiLang"></h3>
                      </td>
                      <td class="text-right">
                        <b>{{ amountToPay | currency }}</b>
                      </td>
                    </tr>
                    <tr *ngFor="let cost of additionalCosts.costs">
                      <td>
                        <div *ngIf="cost.CostDescription" [innerHtml]="cost.CostDescription | multiLang">
                        </div>
                        <div *ngIf="!cost.CostDescription">
                          {{ 'payment.otherCost' | translate}}
                        </div>
                      </td>
                      <td class="text-right">
                        <ng-container *ngIf="cost.Costs">
                          <ng-container *ngFor="let costInterno of cost.Costs">
                              {{costInterno.Amount | currency}} x {{costInterno.Qty | number }} vehículos = {{costInterno.Amount * costInterno.Qty | currency}}
                          </ng-container>
                          <ng-container *ngIf="!cost.Amount && !cost.FixedAmount">
                            {{ 0 | currency }}
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!cost.Costs">
                          <ng-container *ngIf="cost.Amount">
                            {{cost.Amount | currency}} x {{cost.Qty}} = {{cost.Amount * cost.Qty | currency}}
                          </ng-container>
                          <ng-container *ngIf="cost.FixedAmount">
                           {{cost.FixedAmount | currency}} x {{cost.Qty}} = {{cost.FixedAmount * cost.Qty | currency}}
                          </ng-container>
                          <ng-container *ngIf="!cost.Amount && !cost.FixedAmount">
                            {{ 0 | currency }}
                          </ng-container>
                        </ng-container>
                      </td>
                    </tr>
                    <tr *ngFor="let cost of costs">
                      <td [innerHtml]="cost.CostDescription | multiLang">
                      </td>
                      <td class="text-right">
                        {{cost.Amount | currency}} x {{cost.Qty}} = {{cost.Amount * cost.Qty | currency}}
                      </td>
                    </tr>
                    <tr *ngIf="hasRadiationMachines()">
                      <td>
                        {{'payment.radiationMachineCost' | translate}}
                      </td>
                      <td class="text-right">
                        {{radiationMachineCount}} x {{radiationMachineIndividualCost | currency}} = {{additionalCost | currency}}
                      </td>
                    </tr>
                    <tr *ngIf="additionalCost > 0 && !hasRadiationMachines()">
                      <td>
                        {{'payment.additionalCost' | translate}}
                      </td>
                      <td class="text-right">
                        {{additionalCost | currency}}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{'payment.convenienceFee' | translate}}
                      </td>
                      <td class="text-right">
                        {{feeAmount | currency}}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total a Pagar:
                      </td>
                      <td class="text-right totals">
                        {{ calculatedAmount | currency}}
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
          <div class="mt-3" *ngIf="invoiceDescription">
            <h3>Descripción de la factura</h3>
            <div class="card">
              <div class="card-body">
                {{invoiceDescription}}
              </div>
            </div>
          </div>

          <ng-container *ngIf="(form2.controls['PaymentMethod'].value == 1)">
            <button class="btn-size btn-primary-mat"
              [disabled]="(!isValidCardPayment() || isSaving() || paymentType=='Unknown')"
              (click)="tryPay()">
              <ng-container *ngIf="!isSaving()">
                <span>{{'payment.paySubmit' | translate}}</span>
                <mat-icon>send</mat-icon>
              </ng-container>
              <ng-container *ngIf="isSaving()">
                <div class="d-flex align-items-center justify-content-center spinner-wht">
                  <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                </div>
              </ng-container>
            </button>
          </ng-container>

          <ng-container *ngIf="(form2.controls['PaymentMethod'].value == 3)">
            <button class="btn-size btn-primary-mat"
            [disabled]="creditService.balance?.CurrentCreditAmount <= 0"
                            (click)="tryPayCredit()">
                      <ng-container *ngIf="!isSaving()">
                       <span>{{'payment.paySubmit' | translate}}</span>
                      <mat-icon>send</mat-icon>
                      </ng-container>
                      <ng-container *ngIf="isSaving()">
                        <div class="d-flex align-items-center justify-content-center spinner-wht">
                          <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                        </div>
                      </ng-container>
            </button>
          </ng-container>


          <ng-container *ngIf="(form2.controls['PaymentMethod'].value == 4)">
              <button class="btn-size btn-primary-mat"
              [disabled]="!form.controls.AccountNumber.valid || !form.controls.RoutingNumber.valid || !form.controls.PostalCode.valid"
              (click)="tryPayAch()">
                <ng-container *ngIf="!isSaving()">
                  <span>{{'payment.paySubmit' | translate}}</span>
                  <mat-icon>send</mat-icon>
                </ng-container>
                <ng-container *ngIf="isSaving()">
                  <div class="d-flex align-items-center justify-content-center spinner-wht">
                    <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                  </div>
                </ng-container>
              </button>
          </ng-container>

          <ng-container *ngIf="(form2.controls['PaymentMethod'].value == 5) && globals.showEventCodePayment">
            <button class="btn-size btn-primary-mat"
              [disabled]="!eventCodeValid || isSaving()"
              (click)="tryPayWithEventCode()">
              <ng-container *ngIf="!isSaving()">
                <span>{{'payment.paySubmit' | translate}}</span>
                <mat-icon>send</mat-icon>
              </ng-container>
              <ng-container *ngIf="isSaving()">
                <div class="d-flex align-items-center justify-content-center spinner-wht">
                  <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                </div>
              </ng-container>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="this.transactionService.itemToEdit.HasDynamicCosts">
    <div class="payment-container">
      <div class="col-lg-12">
        <h1><b>Checkout</b></h1>
        <p> Aquí podrás abonar tus solicitudes. Selecciona el medio de pago de tu conveniencia. </p>
      </div>
    </div>
    <div class="payment-container" [ngClass]="{'d-none': paymentCompleted}">
      <div class="d-flex" >


        <div class="col-md-6">
          <!-- Sección para seleccionar método de pago -->
          <h3 style="background-color: #155d48; color: white; padding: 10px; border-top-left-radius: 3px; border-top-right-radius: 3px;">
            SELECCIONE EL MÉTODO DE PAGO
          </h3>
          <form [formGroup]="form2">
            <mat-radio-group formControlName="PaymentMethod" (change)="onSelectPayMethod($event)">
              <div class="radio-buttons-container">
                <mat-radio-button class="custom-radio-button" [value]="1" [checked]="true">
                  <b>Tarjeta De Crédito </b>
                </mat-radio-button>
                <mat-radio-button class="custom-radio-button" *ngIf="calculatedAmount > 500" [value]="4">
                  <b>{{'payment.ach' | translate}}</b>
                </mat-radio-button>
                <mat-radio-button class="custom-radio-button"  [value]="3">
                  <b>{{ 'credit.useCredits' | translate }}</b>
                </mat-radio-button>
                <mat-radio-button *ngIf="globals.showEventCodePayment" class="custom-radio-button" [value]="5">
                  <b>Código de Evento</b>
                </mat-radio-button>
                <mat-radio-button class="custom-radio-button" [disabled]="!transactionService.itemToEdit.HasPaymentPlan" [value]="2">
                  <b>{{'payment.paymentPlan' | translate}}</b>
                </mat-radio-button>
              </div>
              <div class="mb-2 mt-2" *ngIf="this.paymentPlan == 2">
                <prgov-alerts class="d-flex justify-content-between">
                  <span>{{'payment.payInstallment' | translate}}</span>
                  <button class="ml-5 btn-primary-outlined-mat" (click)="openDialog()">
                    <span>{{'payment.goToPlan' | translate}}</span>
                    <mat-icon>send</mat-icon>
                  </button>
                </prgov-alerts>
              </div>
            </mat-radio-group>
            <hr>
            <!-- Formulario para ingresar datos de tarjeta -->
            <div [hidden]="this.form2.controls.PaymentMethod.value !== 1" class="pt-3">
              <form [formGroup]="form">
                <input type="text" name="first-name" card-name style="display: none;" />
                <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                  1. Ingrese los datos de su tarjeta
                </h3>
                <div>
                  Completa los detalles de tu tarjeta de crédito para procesar el pago. Asegúrate de ingresar el nombre tal como aparece en la tarjeta.
                </div>
                <div class="form-group pt-3">
                  <mat-form-field appearance="outline">
                    <mat-label>{{'payment.nameOnCard' | translate}} *</mat-label>
                    <input matInput type="text" formControlName="NameOnCard" />
                    <mat-hint class="materialize-red-text" [hidden]="!form.controls.NameOnCard.errors || !form.controls.NameOnCard.touched">
                      {{'payment.cardError' | translate}}
                    </mat-hint>
                  </mat-form-field>
                </div>
                <app-credit-card-selector></app-credit-card-selector>
                <mat-form-field appearance="outline">
                  <mat-label>{{'payment.cardNumber' | translate}} *</mat-label>
                  <input matInput type="tel" name="number" formControlName="CardNumber" (input)="formatValue($event)" />
                  <mat-hint class="materialize-red-text" *ngIf="cardFormatterService.cardType=='Unknown' || form.controls.CardNumber.errors" [hidden]="!form.controls.CardNumber.touched">
                    {{'payment.cardError' | translate}}
                  </mat-hint>
                </mat-form-field>
                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field appearance="outline">
                      <mat-label>{{'payment.expiry' | translate}} (MM/YYYY) *</mat-label>
                      <input matInput type="text" name="expiry" formControlName="Expiry" mask="00 / 0000" [dropSpecialCharacters]="false" />
                      <mat-hint *ngIf="!paymentService.toggleDateFormatError" class="materialize-red-text" [hidden]="!form.controls.Expiry.errors || !form.controls.Expiry.touched">
                        {{'payment.expError' | translate}}
                      </mat-hint>
                      <mat-hint *ngIf="paymentService.toggleDateFormatError" class="materialize-red-text" [hidden]="!form.controls.Expiry.touched">
                        {{'date-format.error' | translate}}
                      </mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field appearance="outline">
                      <mat-label>CVC *</mat-label>
                      <input matInput type="text" name="cvc" formControlName="CVC" (keypress)="numberOnly($event)" maxlength="4" minlength="3"/>
                    </mat-form-field>
                  </div>
                </div>
                <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                  2. Ingrese la dirección asociada a la tarjeta
                </h3>
                <div>
                  Ingresa la direccion asociada a tu tarjeta. Incluye dirección completa, país y código postal, asegurando que coincida con los registros para un pago sin problemas.
               </div>
               <br>
                <app-street-postal-address-form formControlName="PaymentAddress" [showHeaders]="false" [managePostal]="false" [isRequired]="true"></app-street-postal-address-form>
              </form>
            </div>

            <!-- Botones para enviar la información -->
            <div class="row">
            <div class="col-lg-12">
      <!--         <ng-container *ngIf="(form2.controls['PaymentMethod'].value == 1)">
                <button mat-button class="btn-size" color="primary" [disabled]="!form.valid || isSaving() || paymentType=='Unknown'" (click)="tryPay()">
                  <ng-container *ngIf="!isSaving()">
                    {{'payment.paySubmit' | translate}}
                    <mat-icon>send</mat-icon>
                  </ng-container>
                  <ng-container *ngIf="isSaving()">
                    <div class="d-flex align-items-center justify-content-center spinner-wht">
                      <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                    </div>
                  </ng-container>
                </button>
              </ng-container> -->
              <ng-container *ngIf="form2.controls['PaymentMethod'].value == 3">
                    <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                      1. Abonar con créditos
                    </h3>
                    <div>
                      Aplica los créditos disponibles en tu cuenta para abonar este pago. Los créditos se descontaran automáticamente del total. Asegúrate de que los créditos sean suficientes para cubrir el pago.
                    </div>
                    <br>
                    ({{ 'credit.currentBalance' | translate }}:<span class="credit-green-label">&nbsp;{{ creditService.balance?.CurrentCreditAmount ? creditService.balance?.CurrentCreditAmount : 0 | currency }} )</span>
                    <br>
                    <button
                    mat-button
                    class="btn-size"
                    color="primary"
                    [disabled]="isSaving()"
                    (click)="tryBuyCredit()">
                    <span>Añadir Crédito</span>
                    <mat-icon>add</mat-icon>
                  </button>
                  <br>
                  <br>
             <!--        <button mat-button
                            class="btn-size"
                            color="primary"
                            (click)="tryPayCredit()">
                      <ng-container *ngIf="!isSaving()">
                        {{'payment.paySubmit' | translate}}
                        <mat-icon>send</mat-icon>
                      </ng-container>
                      <ng-container *ngIf="isSaving()">
                        <div class="d-flex align-items-center justify-content-center spinner-wht">
                          <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                        </div>
                      </ng-container>
                    </button> -->
              </ng-container>
              <ng-container *ngIf="form2.controls['PaymentMethod'].value == 5 && globals.showEventCodePayment">
                <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                  1. Ingrese su código de evento
                </h3>
                <div class="mb-3">
                  Introduce el código de evento otorgado. El código permite someter su trámite sin costo adicional hasta agotar la cuota disponible.
                </div>
                <div class="d-flex align-items-center mb-2">
                  <mat-form-field appearance="outline" style="flex:1; margin-bottom: -1.34375em">
                    <mat-label>Código de Evento</mat-label>
                    <input matInput type="text" [(ngModel)]="eventCode" [ngModelOptions]="{standalone: true}" (ngModelChange)="onEventCodeChange()" (keyup.enter)="validateEventCode()" [disabled]="eventCodeValidating" style="text-transform:uppercase" />
                  </mat-form-field>
                  <button mat-stroked-button color="primary" [disabled]="!eventCode || eventCodeValidating" (click)="validateEventCode()" class="ml-2" style="height: 56px;">
                    <span *ngIf="!eventCodeValidating">Validar</span>
                    <mat-spinner *ngIf="eventCodeValidating" [diameter]="20"></mat-spinner>
                  </button>
                </div>
                <div *ngIf="eventCodeValid" class="alert alert-success d-flex align-items-center mt-3">
                  <mat-icon class="mr-2">check_circle</mat-icon>
                  <span>Código válido. Usos restantes: <strong>{{ eventCodeRemainingUses }}</strong></span>
                </div>
                <div *ngIf="!eventCodeValid && eventCodeError" class="alert alert-danger d-flex align-items-center mt-3">
                  <mat-icon class="mr-2">error</mat-icon>
                  <span>{{ eventCodeError }}</span>
                </div>
              </ng-container>

              <ng-container *ngIf="form2.controls['PaymentMethod'].value == 4">
                <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                  1. Ingrese los detalles de su cuenta bancaria
                </h3>
                <div>
                  Introduce los datos de tu cuenta, como el número de cuenta, número de ruta y código postal. Aségurate de que toda la información sea precisa y que haya fondos suficientes en tu cuenta para un procesamiento existoso del pago.
                </div>
                <br>
                <form [formGroup]="form">
                  <div class="row mb-5">
                    <div class="col-md-12 col-lg-6">
                      <mat-form-field appearance="outline">
                        <mat-label>{{'ach.accountNumber' | translate}}</mat-label>
                        <input matInput type="number" formControlName="AccountNumber" />
                        <mat-hint class="materialize-red-text" *ngIf="form.controls.AccountNumber.errors">
                          {{'ach.validAccountNumber' | translate}}
                        </mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row mb-5">
                    <div class="col-md-12 col-lg-6">
                      <mat-form-field appearance="outline">
                        <mat-label>{{'ach.routingNumber' | translate}}</mat-label>
                        <input matInput type="text" formControlName="RoutingNumber" />
                        <mat-hint class="materialize-red-text" *ngIf="form.controls.RoutingNumber.errors">
                          {{'ach.validRoutingNumber' | translate}}
                        </mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row mb-5">
                    <div class="col-md-12 col-lg-6">
                      <mat-form-field appearance="outline">
                        <mat-label class="t-w-w-s">{{'streetPostalAdressFormComponent.GENERAL_INFO_COMPANY_POSTAL_CODE' | translate}}</mat-label>
                        <input mask="00000" matInput formControlName="PostalCode" [required]="this.isRequired" >
                        <mat-hint class="materialize-red-text" [hidden]="!form.controls.PostalCode.errors || !form.controls.PostalCode.touched">
                          {{'GLOBAL.REQUIRED_FIELD' | translate}}
                        </mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
      <!--             <button mat-button class="btn-size" color="primary" (click)="tryPayCredit()">
                    <ng-container *ngIf="!isSaving()">
                      {{'payment.paySubmit' | translate}}
                      <mat-icon>send</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="isSaving()">
                      <div class="d-flex align-items-center justify-content-center spinner-wht">
                        <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                      </div>
                    </ng-container>
                  </button> -->
                </form>
              </ng-container>
            </div>
          </div>
          </form>
          <!-- Mensaje de error del servidor -->
          <div class="row" *ngIf="serverError != ''">
            <div class="col col-sm-12">
              <div class="server-error h4">{{serverError}}</div>
            </div>
          </div>
          <div class="mb-5"></div>
        </div>

            <!-- Columna para costos dinámicos a la izquierda -->
            <div class="col-md-6">
              <div class="row mt-3 mb-3">
                <div class="col-lg-12">
                  <h3 style="background-color: #155d48; color: white; padding: 10px; border-radius: 3px;">
                    ORDEN DE SOLICITUDES A ABONAR
                  </h3>
                </div>
              </div>
              <h2 [innerHTML]="transactionService.itemToEdit.ProcessName | multiLang"></h2>
            <!--   <div class="totals">
                Total {{ calculatedAmount | currency}}
              </div> -->
              <div class="table-container m-b-10">
             <!--    <h2>{{'payment.title' | translate}}</h2> -->
                <table class="table mb-0" >
                  <tbody>
                    <ng-container *ngIf="dynamicCosts">
                      <!-- Fila para cada costo dinámico -->
                      <tr *ngFor="let cost of dynamicCosts.Costs">
                        <td [innerHtml]="cost.CostDescription | multiLang"></td>
                        <td class="text-right" *ngIf="cost.FixedAmount == 0 || cost.FixedAmount == NULL">
                          {{cost.Amount | currency}} x {{cost.Qty}} = {{cost.Amount * cost.Qty | currency}}
                        </td>
                        <td class="text-right" *ngIf="cost.FixedAmount > 0">
                          {{cost.FixedAmount | currency}} x {{cost.Qty}} = {{cost.FixedAmount * cost.Qty | currency}}
                        </td>
                      </tr>
                      <!-- Fila para subtotal -->
                      <tr>
                        <td>Subtotal</td>
                        <td class="text-right">{{ costDetails.TotalAmount | currency}}</td>
                      </tr>
                      <!-- Fila para tarifa de conveniencia -->
                      <tr>
                        <td>{{'payment.convenienceFee' | translate}}</td>
                        <td class="text-right">{{ costDetails.FeeAmount }}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
                <div *ngFor="let cost of dynamicCosts" class="totals">
                  COSTO TOTAL DE GESTIÓN: {{cost.CalculatedAmount | currency}}
                </div>
              </div>

              <ng-container *ngIf="(form2.controls['PaymentMethod'].value == 1)">
                <button class="btn-size btn-primary-mat"
                  [disabled]="(!isValidCardPayment() || isSaving() || paymentType=='Unknown')"
                  (click)="tryPay()">
                  <ng-container *ngIf="!isSaving()">
                    <span>{{'payment.paySubmit' | translate}}</span>
                    <mat-icon>send</mat-icon>
                  </ng-container>
                  <ng-container *ngIf="isSaving()">
                    <div class="d-flex align-items-center justify-content-center spinner-wht">
                      <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                    </div>
                  </ng-container>
                </button>
              </ng-container>

            <ng-container *ngIf="(form2.controls['PaymentMethod'].value == 3)">
              <button class="btn-size btn-primary-mat"
                              (click)="tryPayCredit()">
                        <ng-container *ngIf="!isSaving()">
                          <span>{{'payment.paySubmit' | translate}}</span>
                          <mat-icon>send</mat-icon>
                        </ng-container>
                          <ng-container *ngIf="isSaving()">
                            <div class="d-flex align-items-center justify-content-center spinner-wht">
                              <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                            </div>
                          </ng-container>
                </button>
              </ng-container>


            <ng-container *ngIf="(form2.controls['PaymentMethod'].value == 4)">
                <button class="btn-size btn-primary-mat"
                (click)="tryPayAch()">
                  <ng-container *ngIf="!isSaving()">
                    <span>{{'payment.paySubmit' | translate}}</span>
                    <mat-icon>send</mat-icon>
                  </ng-container>
                    <ng-container *ngIf="isSaving()">
                      <div class="d-flex align-items-center justify-content-center spinner-wht">
                        <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                      </div>
                    </ng-container>
                  </button>
              </ng-container>

              <ng-container *ngIf="(form2.controls['PaymentMethod'].value == 5) && globals.showEventCodePayment">
                <button class="btn-size btn-primary-mat"
                  [disabled]="!eventCodeValid || isSaving()"
                  (click)="tryPayWithEventCode()">
                  <ng-container *ngIf="!isSaving()">
                    <span>{{'payment.paySubmit' | translate}}</span>
                    <mat-icon>send</mat-icon>
                  </ng-container>
                  <ng-container *ngIf="isSaving()">
                    <div class="d-flex align-items-center justify-content-center spinner-wht">
                      <mat-spinner [diameter]="20" class="button-spinner"></mat-spinner>
                    </div>
                  </ng-container>
                </button>
              </ng-container>
            </div>


      </div>
    </div>
  </ng-container>

  <div class="payment-success d-flex align-items-center justify-content-center flex-column"
       *ngIf="paymentCompleted">
    <div class="icon">
      <i class="material-icons left">check</i>
    </div>
    <div class="amount">{{totalCost | currency}}</div>
    <div class="message">{{'payment.complete' | translate}}</div>
    <div class="message mt-2" style="font-size:medium">{{'payment.verificationCode' | translate}}:</div>
    <div class="message" style="font-size:medium">{{this.authNumber}}</div>
    <div class="row mt-2">
      <div class="col-lg-6 col-xl-6 col-sm-6 col-xs-12 p-1">
        <button class="w-100 btn-primary-mat" (click)="viewInvoice()">
          {{'payment.viewReceipt' | translate}}
        </button>
      </div>
      <div class="col-lg-6 col-xl-6 col-sm-6 col-xs-12 p-1">
        <button class="w-100 btn-primary-outlined-mat" [disabled]="this.isSaving()" (click)="backToTransaction()">
          {{ 'transactionManagement.myRequest' | translate }}
        </button>
      </div>
    </div>
  </div>
  <ng-template #terms>
  </ng-template>
</div>
